import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useState } from "react";
import { toast } from "react-toastify";

/**
 * useStake - 定期质押 Hook（交易类）
 *
 * 用于调用 RegularStaking 合约的 stake 方法进行定期质押。
 * 通过 tx.wait() 等待交易确认，使用 toast 显示交易结果提示。
 *
 * @returns {Object} 返回质押方法和加载状态
 *   - stake: 执行质押的函数
 *   - stakeLod: 加载状态，表示交易是否正在进行中
 */
const useStake = () => {
  // 获取合约
  const {
    contractEvm: { RegularStaking },
  } = useConnectWallet();
  // loading
  const [stakeLod, setLoading] = useState(false);

  /**
   * 质押函数
   * @param amount - 质押金额
   * @param unlockCycle - 质押周期（天数）
   * @param toastText - toast 提示文本
   * @param suuFun - 成功回调函数
   * @param errFun - 失败回调函数
   */
  const stake = async (
    amount: bigint,
    unlockCycle: number,
    toastText: { success: string; error: string },
    suuFun?: () => void,
    errFun?: () => void,
  ) => {
    if (RegularStaking) {
      setLoading(true);
      try {
        // 调用合约的 stake 方法
        const tx = await RegularStaking.stake(amount, unlockCycle);
        // 等待交易确认
        await tx.wait();
        // 显示成功提示
        toast.success(toastText.success);
        // 成功后调用成功回调函数
        suuFun && suuFun();
      } catch (e) {
        console.log("useStake", e);
        // 失败后调用失败回调函数
        errFun && errFun();
        // 显示失败提示
        toast.error(toastText.error);
      } finally {
        setLoading(false);
      }
    }
  };

  return { stake, stakeLod };
};

export default useStake;
